<script lang="ts" setup>
const { name, terms } = defineProps<{
  name: string
  terms: string[]
}>()

const {
  setSearch,
} = useQuickSearch()
</script>

<template>
  <div
    :aria-label="name"
    role="region"
    class="search__group"
  >
    <div
      class="search__heading"
      aria-hidden="true"
    >
      {{ name }}
    </div>

    <ul class="search__list">
      <li
        v-for="term in terms"
        :key="term"
        class="search__item"
      >
        <button
          type="button"
          class="search__link"
          @click="setSearch(term)"
        >
          <span>{{ term }}</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<style>
/* @import url("~layers/components/Search/Terms.css"); */
</style>
